<template>
  <label class="olyo-checkbox" tabindex="-1" role="checkbox" @click.prevent="toggle">
    <input type="checkbox" :checked="modelValue" />
    <svg v-if="showCheckedIcon" width="15" height="14" viewBox="0 0 15 14">
      <path
          d="M7.375 13.8622C3.5089 13.8622 0.375 10.831 0.375 7.09164C0.375 3.35224 3.5089 0.321045 7.375 0.321045C11.2411 0.321045 14.375 3.35224 14.375 7.09164C14.375 10.831 11.2411 13.8622 7.375 13.8622ZM6.6771 9.79988L11.6261 5.01239L10.637 4.05503L6.6771 7.88515L4.6968 5.96975L3.707 6.92711L6.6771 9.79988Z"
          fill="white"/>
    </svg>
    <svg v-else width="15" height="14" viewBox="0 0 15 14">
      <path
          d="M7.375 13.8622C3.5089 13.8622 0.375 10.831 0.375 7.09164C0.375 3.35224 3.5089 0.321045 7.375 0.321045C11.2411 0.321045 14.375 3.35224 14.375 7.09164C14.375 10.831 11.2411 13.8622 7.375 13.8622Z"
          fill="white"/>
    </svg>
    <span class="checkbox-label">
      <slot/>
    </span>
  </label>
</template>

<script>
export default {
  name: 'OlyoCheckbox',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showCheckedIcon() {
      return !!this.modelValue;
    }
  },
  methods: {
    toggle() {
      this.$emit('update:modelValue', !this.modelValue);
    }
  }
};
</script>

<style scoped>
.olyo-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  gap: 5px;
  font-size: .8rem;
  line-height: 1;
}

input[type="checkbox"] {
  display: none;
}

.checkbox-label {
  font-family: sans-serif;
}
</style>